export { default } from './AttachmentVideoInput';
